import { L10n } from '../L10n/L10n';
import { Set } from '../models/Set';
import { Module } from '../Module';
import { Schedules } from '../resources/Schedules';
import { ISchedule } from '../../schedule/types/ISchedule';
import { AbstractContentAction } from '../../commonInfra/contentActions/AbstractContentAction';
import { ConfirmActionDialog, IConfirmActionDialogOptions } from './ConfirmActionDialog';
import {
  standardActionErrorMsg,
  standardActionSuccessMsg
} from '../../commonInfra/contentActions/ActionHelpers';
import { Messages } from '../../codegen/Localize';

export class RunServerSchedulesAction extends AbstractContentAction<ISchedule> {

  public static $inject = ['ConfirmActionDialog', '$translate', 'Schedules'];

  constructor(
            ConfirmActionDialog: ConfirmActionDialog,
    private $translate: ng.translate.ITranslateService,
    private Schedules: Schedules
  ) {
    super(ConfirmActionDialog);
  }

  configureDialog(dialogConfig: IConfirmActionDialogOptions, schedules: Set<ISchedule>) {
    dialogConfig.bodyText = this.$translate.instant('schedulesRunPrompt', {
      ITEM_COUNT: schedules.size(),
      ITEM_NAME: L10n.elideIfLong(schedules.first().name)
    }, L10n.Interpolations.Count);
    dialogConfig.title = this.$translate.instant('runNow');
    dialogConfig.actionName = this.$translate.instant('runNowConfirmButton', {
      ITEM_COUNT: schedules.size()
    }, L10n.Interpolations.Count);
    dialogConfig.action = () => this.Schedules.runServer(schedules.keys());
  }

  notificationTranslationFns() {
    return {
      successMsg: standardActionSuccessMsg(Messages.schedulesRunSuccess),
      errorMsg: standardActionErrorMsg(Messages.schedulesRunError),
    };
  }

}

Module.instance().service('RunServerSchedulesAction', RunServerSchedulesAction);
